import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

type Tone = 'neutral' | 'primary' | 'secondary' | 'error'

const TONES: Record<Tone, string> = {
  neutral: 'border-glass-border bg-white/5 text-fg-muted',
  primary: 'border-primary-container/30 bg-primary-container/15 text-primary',
  secondary:
    'border-secondary-container/30 bg-secondary-container/15 text-secondary',
  error: 'border-error/20 bg-error/10 text-error',
}

interface PillProps {
  tone?: Tone
  className?: string
  children: ReactNode
}

/** Non-interactive status/metadata badge. */
export function Pill({ tone = 'neutral', className, children }: PillProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-1',
        'font-body text-label-caps uppercase',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
